import ClaimListing from 'app/shared/model/ClaimListing';

const ClaimMethods = ({
    phones = [],
    emails = [],
} = {}) => ({
    phones: phones.map(String),
    emails: emails.map(String),
});

const ClaimPropertyLookupAll = ({
    totalContactMethodCount = 0,
    contactMethods = [],
    totalListingCount = 0,
    listings = [],
} = {}) => ({
    totalContactMethodCount: Number(totalContactMethodCount),
    contactMethods: new ClaimMethods(contactMethods),
    totalListingCount: Number(totalListingCount),
    listings: listings.map(ClaimListing),
});

export default ClaimPropertyLookupAll;
